import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation Mutation($data: CreatePopUpInput!) {
    createPopUp(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createPopUp: {
    id: number;
  };
}
